import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConstantsService } from 'src/app/services/constants.service';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class AccionService {
  public url = ConstantsService.ACCIONES_URL;
  private urlArchivos = ConstantsService.ACCIONES_FILE_URL;
  constructor(private http: HttpClient) { }

  create(formData: any): Observable<any> {
    return this.http.post(`${this.url}`, formData).pipe(map(data => {
      return data;
    }));
  }
  
  list(query: string = ''): Observable<any> {

    return this.http.get(`${this.url}${query}`).pipe(map(
     data => {return data;}
   ));
 }

  update(formData: any): Observable<any> {
    let { idSprAccion } = formData;
    return this.http.patch(`${this.url}${idSprAccion}`, formData).pipe(map(
      data => {
        return data;
      }
    ));
  }
  delete(dataDelete: any): Observable<any> {
    return this.http.patch(`${this.url}${dataDelete.idSprAccion}`, dataDelete)
  }

  postArchivo(formData:any, id:number): Observable<any>{

    return this.http.post(`${this.urlArchivos}/`+ id, formData).pipe(map(data => {
      return data;
    }));
  }

  download(name:string): Observable<any>{
    return this.http.get(`${this.urlArchivos}/`+ name)
  }


}
